import { css } from 'styled-components';
import {
  getSpacing,
  SpacingName,
  getTypography,
  TypographyName,
  ThemedFunctor,
  BreakpointQueryName,
} from '@doveit/lego';
import variables from '../../themes/variables';

export const header: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginBottom(theme, SpacingName.MEDIUM)}
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
  ${getTypography(theme, TypographyName.H2)}
  color: ${theme.palettes.brand.primary};
`;

export const categories: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
`;

export const stickySideAdv: ThemedFunctor = ({
  theme,
  $visible,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  display: none;
  position: sticky;
  transition: opacity .4s ease-out;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block;
    opacity: ${$visible ? 1 : 0};
    pointer-events: ${$visible ? 'all' : 'none'};
    top: calc(${variables.navigationHeight.desktop} + ${theme.spaceUnits.desktop.MEDIUM});
  }
`;

export const footer: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
`;
